import React, { Component } from 'react'
import Notification from "../layout/Notification"
import Pagination from "react-js-pagination"
import { addCurrentRoute } from '../../actions/profile_action'
import { connect } from "react-redux"
import Helping from '../../helpers/Helping'
import Service from '../../helpers/service'
import { API_URL, MATIC_TRANSACTION_HASH_LINK } from '../../config/urls'
import { MESSAGE, ROLE, ROUTE_ACCESS } from '../../config/index'

const {
	NOT_FOUND, TRANSFER
} = MESSAGE

class List extends Component {
	constructor(props) {
		super(props)

		this.state = {
			stacks: [],
			transaction_hash: '',
			type: '',
			url: API_URL.ADMIN_API + 'campaign-transfer-batch',
			urlReports: API_URL.ADMIN_TRADING_API + 'reports',
			error_message: '',
			error_type: '',
			isLoading: false,
			btnIsDisable: true
		}

		this.onTransfer = this.onTransfer.bind(this)
		this.btnEnable = this.btnEnable.bind(this)
		this.scrollToTop = this.scrollToTop.bind(this)
		this.getStacks = this.getStacks.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)
		this.pageRefreshFunction = this.pageRefreshFunction.bind(this)
	}

	componentDidMount() {
		this.scrollToTop()
		this.getStacks()
	}

	handleValueChange(e) {
		const { name, value } = e.target
		this.setState({ [name]: value })
	}

	async getStacks() {
		let $this = this

		let data = {
			action: "campaign-stats",
		}

		await Service.postCall($this.state.urlReports, data).then(response => {
			this.setState(
				{
					stacks: response.data.payload,
				})
		}).catch(error => {
		})
	}

	onTransfer(e) {
		e.preventDefault()
		let $this = this

		let data = {
			campaign_type: $this.state.type,
		}

		Service.postCall($this.state.url, data).then(response => {
			this.setState(
				{
					transaction_hash: response.data.payload.hash,
					type: '',
					btnIsDisable: true,
					error_message: Helping.getMessageString(TRANSFER, 'Transfer'),
					error_type: "success",
				}
			)
		}).catch(error => {
			if (error.response) {
				Helping.redirectToLogin(error)
				return $this.setState({
					error_message: error.response.data.message,
					error_type: 'danger',
				})
			}
			return this.setState({
				isLoading: false,
			})
		})
	}

	btnEnable() {
		if (this.state.type) {
			this.setState({ btnIsDisable: false })
		}
		else {
			this.setState({ btnIsDisable: true })
		}
	}

	pageRefreshFunction(e) {
		e.preventDefault()

		this.setState({
			stacks: [],
			transaction_hash: '',
			type: '',
			url: API_URL.ADMIN_API + 'campaign-transfer-batch',
			urlReports: API_URL.ADMIN_TRADING_API + 'reports',
			error_message: '',
			error_type: '',
			isLoading: false,
			btnIsDisable: true
		},
			() => this.getStacks())
	}


	scrollToTop() {
		window.scrollTo({
			top: 1,
			left: 1,
			behavior: 'smooth'
		})
	}

	getTransactionHashLink = (item) => {
		return MATIC_TRANSACTION_HASH_LINK + item
	}

	render() {
		return (
			<>
				<div class="content user-list">
					<div class="top-header">
						<div class="header-title">
							<h2 class="title">Campaign Transfer</h2>
							<span class="title-caption">You can transfer compaign and see stacks here.</span>

							<form class="header-form" onSubmit={this.onTransfer}>
								<div class="form-group">
									<label for="transferType">Types</label>
									<select class="form-select" aria-label="Default select example" id="transferType" name="type" value={this.state.type} onChange={(e) => this.handleValueChange(e)}>
										<option value="" selected>Select Type...</option>
										{/* <option value="ISL">{Helping.getTitleCase("ISL")}</option> */}
										<option value="CMC">{Helping.getTitleCase("CMC")}</option>
										{/* <option value="CARDANO">{Helping.getTitleCase("CARDANO")}</option> */}
									</select>
								</div>
								<button type="submit" class="custom-btn sm-btn gradiant-btn" disabled={!this.state.type}>Transfer</button>
							</form>

						</div>
					</div>

					<div class="main-content">
						{this.state.error_message &&
							<Notification
								type={this.state.error_type}
								message={this.state.error_message}
								callback={this.removeNetworkError}
							/>
						}
						<div class="stack-listing table-responsive">
							<table class="table">
								<thead>
									<tr>
										<th class="tbl-sorting" scope="col">Name</th>
										<th class="tbl-sorting userFullName" scope="col" >Pending</th>
										<th class="tbl-sorting" scope="col" >Processing</th>
										<th class="tbl-sorting" scope="col" >Confirmed</th>
									</tr>
								</thead>
								{(this.state.stacks.length > 0) && (
									<tbody>
										{Object.keys(this.state.stacks).map((key, index) => (
											Object.values(this.state.stacks[index]).map((val, i) => (
												<tr key={index}>
													<td>{Object.keys(this.state.stacks[index])}</td>
													<td>{val.pending ? val.pending : 0}</td>
													<td>{val.processing ? val.processing : 0}</td>
													<td>{val.confirmed ? val.confirmed : 0}</td>
												</tr>
											))
										))}
									</tbody>
								)}
							</table>
						</div>

						{this.props.total > 0 && (
							<div class="table-bottom">
								<div class="dataTables_length">
									<label>Show
										<select
											name="userDataTable_length"
											value={this.props.limit}
											onChange={(e) => this.handleLimitChange(e.target.value)}
										>
											<option value="10">10</option>
											<option value="25">25</option>
											<option value="50">50</option>
											<option value="100">100</option>
										</select> of {this.props.total}</label>
								</div>
								<Pagination
									// hideFirstLastPages
									activePage={this.props.page}
									itemsCountPerPage={this.props.limit}
									totalItemsCount={this.props.total}
									pageRangeDisplayed={5}
									onChange={this.handlePageChange}
									itemClass='page-item'
									linkClass='page-link'
									prevPageText='Pre'
									nextPageText='Next'
									firstPageText='First'
                                    lastPageText='Last'
									innerClass="dataTables_paginate"
									linkClass="paginate_button"
									activeLinkClass="paginate_button current"
									disabledClass="paginate_button disabled"
								/>
							</div>
						)}

						{(this.props.total < 1 && !this.props.isLoading) && (
							<div className='table-responsive'>
								<Notification
									type='danger'
									message={Helping.getMessageString(
										NOT_FOUND,
										'Users '
									)}
									callback={this.removeNetworkError}
								/>
							</div>
						)}
					</div>
				</div>
			</>
		)
	}
}

const mapStateToProps = state => ({
	profile: state.profile,
})

const mapDispatchToProps = {
	addCurrentRoute
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(List)